import {AdapterProps, FieldAdapter} from '../field-factory';
import {
  Radio as MantineRadio,
  RadioGroupProps,
  RadioProps,
} from '@mantine/core';
import {FC, useContext} from 'react';
import {ReadOnlyContext} from '../readonly-context';

export type $RadioGroupAdapterProps = AdapterProps<RadioGroupProps>;

export const $RadioGroupAdapter: FC<FieldAdapter<$RadioGroupAdapterProps>> = ({
  inputProps: {onChange, ...inputProps},
  control,
}) => {
  const {
    field: {onChange: fieldOnChange, ...fieldProps},
    fieldState: {invalid},
  } = control;

  const _onChange: RadioGroupProps['onChange'] = (value) => {
    fieldOnChange(value);
    onChange?.(value);
  };

  return (
    <MantineRadio.Group
      error={invalid}
      onChange={_onChange}
      {...fieldProps}
      {...inputProps}
    />
  );
};

export const $RadioGroupItemAdapter = ({disabled, ...props}: RadioProps) => {
  const {readOnly} = useContext(ReadOnlyContext);
  return <MantineRadio {...props} disabled={disabled || readOnly} />;
};